import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/layout'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home',
    component: Layout,
    children: [
      {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/home')
      },
      {
        path: '/search',
        name: 'Search',
        component: () => import('@/views/search')
      },
      {
        path: '/prod-introduce',
        name: 'ProdIntroduce',
        component: () => import('@/views/prod-introduce')
      },
      {
        path: '/news',
        name: 'News',
        component: () => import('@/views/news')
      },
      {
        path: '/news/news-detail',
        name: 'News',
        component: () => import('@/views/news-detail')
      },
      {
        path: '/about',
        name: 'About',
        component: () => import('@/views/about')
      },
      {
        path: '/blockchain-service',
        name: 'BlockchainService',
        component: () => import('@/views/blockchain-service')
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login')
  }
]

const router = new VueRouter({
  routes
})

export default router
